<template>
  <div style="height: 100%; max-width: 500px" class="mx-auto">
    <div style="height: 100%" v-if="!loadingpdpa && termCondition">
      <div
        class="mx-auto Kanit"
        style="
          display: flex;
          flex-flow: column;
          position: absolute;
          height: 100%;
          max-width: 500px;
          width: 100%;
        "
      >
        <div
          class="primary pa-4 text-center white--text Kanit"
          style="font-size: 22px"
        >
          ข้อกำหนดและเงื่อนไข
        </div>

        <template>
          <v-card
            class="ma-4 pa-3"
            style="overflow-y: scroll; font-size: 15px"
            color="#eee"
          >
            <div class="ALL-CONTENT-HERE Kanit" v-if="termCondition">
              <div v-html="termCondition.term_condition"></div>
            </div>
            <div v-if="!$store.state.checkPdpaStatus">
              <v-checkbox
                style="font-weight: 600"
                label="ข้าพเจ้าได้อ่าน และยอมรับข้อตกลงและเงื่อนไข"
                v-model="cbagree"
              ></v-checkbox>
            </div>
          </v-card>

          <template v-if="!$store.state.checkPdpaStatus">
            <div class="pa-5 mb-3 pt-0">
              <v-btn
                @click="handleSubmitPdpa"
                :loading="saveloading"
                :disabled="!cbagree"
                style="font-size: 22px"
                class="text-capitalize"
                color="primary"
                :dark="cbagree"
                block
                >ยอมรับ</v-btn
              >
              <v-btn
                @click="$liff.closeWindow()"
                style="font-size: 22px"
                class="mt-3 text-capitalize"
                color="#eee"
                :loading="saveloading"
                block
                >ไม่ยอมรับ</v-btn
              >
            </div>
          </template>
          <template v-else-if="$store.state.isCancelPdpa">
            <div class="pa-5 mb-3 pt-0">
              <v-btn
                @click="handleCancelTerms"
                :loading="saveloading"
                style="font-size: 22px"
                class="text-capitalize"
                color="error"
                :dark="cbagree"
                block
                >เพิกถอนความยินยอม</v-btn
              >
              <v-btn
                @click="handleBackPage"
                style="font-size: 22px"
                class="mt-3 text-capitalize"
                color="#eee"
                :loading="saveloading"
                block
                >กลับ</v-btn
              >
            </div>
          </template>
        </template>
      </div>
    </div>
    <div class="text-center" v-else>
      <v-progress-circular
        size="65"
        color="primary"
        indeterminate
        class="mt-10"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      saveloading: false,
      cbagree: false,
      termCondition: null,
      loadingpdpa: true,
    };
  },
  async mounted() {
    await this.handleGetPdpa();
  },
  methods: {
    async handleGetPdpa() {
      const vm = this;
      try {
        const data = {
          userid: vm.userid,
          pageid: vm.query.pageid,
        };

        vm.loadingpdpa = true;
        let response = null;
          response = await vm.getNewPdpa(data);
        vm.loadingpdpa = false;

        if (response && response.status === 200) {
          const pdpaStatus = response.data.pdpa;
          const isCancelPdpa = vm.$store.state.isCancelPdpa;
          vm.$store.state.checkPdpaStatus = pdpaStatus;

          if ((!pdpaStatus && !isCancelPdpa) || (pdpaStatus && isCancelPdpa)) {
            vm.termCondition = response.data.term_condition;
          } else {
            const isMember =
              vm.$store.state.member &&
              Object.keys(vm.$store.state.member).length > 0;
            if (
              isMember &&
              ["Login", "Register"].includes(vm.$store.state.redirectview)
            ) {
              vm.query.tab = "profile";
              vm.query.view = "PointManager";
            } else {
              vm.query.view = vm.$store.state.redirectview;
            }
          }
        } else {
          await vm.$swal.fire({
            text: response.data.reason,
          });
          if (response.data.responsecode == 400) {
            vm.$liff.closeWindow();
          }
        }
      } catch (error) {
        console.error(error);
        vm.loadingpdpa = false;
      }
    },
    async getNewPdpa(data) {
      const vm = this;
      try {
        const url = `${vm.serverUrl}toacrm/api/liff/pdpa`;
        const response = await axios.get(url, {
          headers: { AUTHORIZATION: "Bearer xxx xxx" },
          params: data,
        });

        if (response) {
          return response;
        } else {
          return null;
        }
      } catch (error) {
        console.error(error);
        return null;
      }
    },
    async getPdpa(data) {
      const vm = this;
      try {
        const url = `${vm.serverUrl}toacrm/pdpa`;
        const response = await axios.get(url, {
          headers: { AUTHORIZATION: "Bearer xxx xxx" },
          params: data,
        });

        if (response) {
          return response;
        } else {
          return null;
        }
      } catch (error) {
        console.error(error);
        return null;
      }
    },
    async handleCancelTerms() {
      await this.$swal
        .fire({
          icon: "info",
          iconColor: "#dc000c",
          html:
            "หากเพิกถอนความยินยอม<br/> สถานะสมาชิก <br/>" +
            "และคะแนนสะสมของท่านจะถูกลบออกทั้งหมด<br/>ไม่สามารถนำกลับมาใช้ต่อได้อีกต่อไป",
          showCancelButton: true,
          confirmButtonText: "ยืนยันการเพิกถอน",
          cancelButtonText: "ออก",
          customClass: "custom-swal-cancel",
          reverseButtons: true,
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            this.cancelTerms();
          }
        });
    },
    async cancelTerms() {
      const vm = this;
      try {
        let data = {
          userid: vm.userid,
          pageid: vm.query.pageid,
        };

        vm.saveloading = true;
        const url = `${vm.serverUrl}toacrm/api/liff/pdpa/cancel`;
        const response = await axios.put(url, data, {
          headers: {
            AUTHORIZATION: "Bearer xxx xxx",
          },
        });
        vm.saveloading = false;

        if (response && response.status === 200) {
          vm.$liff.closeWindow();
        } else {
          await vm.$swal.fire({
            text: response.data.reason,
          });
          vm.$liff.closeWindow();
        }
      } catch (error) {
        console.error(error);
        vm.saveloading = false;
      }
    },
    handleBackPage() {
      this.$store.state.isCancelPdpa = false;
      this.$store.state.redirectview = this.query.view;
      this.query.view = "PointManager";
    },
    async handleSubmitPdpa() {
      const vm = this;
      try {
        vm.saveloading = true;
        let response = null;
          response = await vm.submitTermCondition();
        vm.saveloading = false;

        if (response && response.status === 200) {
          vm.query.tab = "profile";
          vm.query.view = "PointManager";
        } else {
          await vm.$swal.fire({
            text: response.data.reason,
          });
          vm.$liff.closeWindow();
        }
      } catch (error) {
        console.error(error);
        vm.saveloading = false;
      }
    },
    async submitTermCondition() {
      const vm = this;
      try {
        const data = {
          userid: vm.userid,
          pageid: vm.query.pageid,
          term_condition_id: vm.termCondition.id,
        };

        const url = `${vm.serverUrl}toacrm/api/liff/pdpa`;
        const response = await axios.post(url, data, {
          headers: {
            AUTHORIZATION: "Bearer xxx xxx",
          },
        });

        if (response) {
          return response;
        } else {
          return null;
        }
      } catch (error) {
        console.error(error);
        return null;
      }
    },
    async submitpdpa() {
      const vm = this;
      try {
        const data = {
          userid: this.userid,
          pageid: this.query.pageid,
        };

        vm.saveloading = true;
        const url = `${vm.serverUrl}toacrm/pdpa`;
        const response = await axios.post(url, data, {
          headers: {
            AUTHORIZATION: "Bearer xxx xxx",
          },
        });
        vm.saveloading = false;

        if (response) {
          return response;
        } else {
          return null;
        }
      } catch (error) {
        console.error(error);
        return null;
      }
    },
  },
};
</script>

<style lang="scss">
html {
  height: 100%;
}
</style>
